const cartoApiKey = (import.meta.env.VITE_CARTO_API_KEY ?? '').trim();

export function getBasemapUrl(theme: 'light' | 'dark') {
  const style = theme === 'dark' ? 'dark_all' : 'light_all';
  const cartoUrl = `https://basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png`;
  if (cartoApiKey) return `${cartoUrl}?key=${encodeURIComponent(cartoApiKey)}`;
  return cartoUrl;
}

export function getBasemapAttribution() {
  return '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
}
